export const getConvertedDuration = (duration?: number) => {
  if (!duration) {
    return;
  }

  const minutes = Math.trunc(duration / 60);
  const seconds = duration % 60;

  const minutesText = minutes ? `${minutes} min` : "";
  const secondsText = seconds ? `${seconds} sec` : "";

  return [minutesText, secondsText].filter(Boolean).join(" ");
};

export const getConvertedDurationHoursMins = (duration?: number) => {
  if (!duration) {
    return;
  }

  const hours = Math.trunc(duration / (60 * 60));
  const minutes = Math.trunc((duration - hours * 60 * 60) / 60);

  const hoursText = hours ? `${hours} hr` : "";
  const minutesText = minutes ? `${minutes} min` : "";

  return [hoursText, minutesText].filter(Boolean).join(" ");
};

export const getDurationSeconds = ({
  hours,
  minutes,
  seconds,
}: {
  hours: string;
  minutes: string;
  seconds: string;
}) => {
  return minutes || seconds
    ? [
        Number.parseInt(hours) * 60 * 60,
        Number.parseInt(minutes) * 60,
        Number.parseInt(seconds),
      ]
        .filter(Boolean)
        .reduce((a, b) => a + b, 0)
    : undefined;
};

export const reorder = (list: any[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
